<template>
  <div class="ding-myPage" v-loading="pageLoading">
    <div class="my-info-cont">
      <div class="my-info-head">
        <!-- <img v-if="userInfo.logoFileUrl" :src="userInfo.logoFileUrl" alt="">
        <span v-else>{{getTrueName}}</span> -->
        <span>{{getTrueName}}</span>
      </div>
      <div class="my-info-txt">
        <div class="my-info-tit">{{userInfo.trueName}}<span v-if="userInfo.trueNameEn">({{userInfo.trueNameEn}})</span></div>
        <div>一链账号：{{userInfo.email}}</div>
      </div>
    </div>
    <div class="my-theme-cont">
      <div class="my-theme-item">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_building.svg" alt="">
        <span class="">企业切换</span>
        <span class="my-theme-fl my-theme-fl2" @click="openChangeCompany"><span class="my-theme-ellipsis">{{userInfo.companyName}}</span></span>
      </div>
      <div class="my-theme-item" @click="openManage">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_manage.svg" alt="">
        <span>企业管理员</span>
        <span class="my-theme-fl">&nbsp;</span>
      </div>
    </div>
    <div class="my-quit" @click="openQuit">安全退出</div>
    <company-change :show="companyShow" :list="userInfo.orgs" :listValue="userInfo.companyId" @changeItem="changeItem" @closeDailog="closeCompanyDailog"></company-change>
    <manage-list ref="manageList" :show="manageListShow" @closeDailog="closeManageDailog"></manage-list>

    <el-dialog
      title=""
      :visible.sync="quitDialog"
      width="80%"
      class="ding-quit-dialog"
      :show-close="false"
      :before-close="quitHandleClose">
      <div class="quit-body-cont">
        <div class="quit-body-item1">是否确定退出？</div>
        <!-- <div class="quit-body-item2">0516-87796393</div> -->
      </div>
      <div slot="footer" class="dialog-footer quit-dialog-footer">
        <div class="quit-btn-left" @click="quitDialog = false">取消</div>
        <div class="quit-btn-right" @click="quitClick()">确定退出</div>
      </div>
    </el-dialog>
    <toopbar></toopbar>
  </div>
</template>
<script>
  import companyChange from './components/companyChange.vue'
  import manageList from './components/manageList.vue'
  import toopbar from './components/toopbar.vue'
  import { mapState } from 'vuex'
  import { get, remove, set } from "js-cookie";
  import { removeStorage, setStorage } from "@/assets/js/storage";
  import {onelink_mdata_userinfo} from "@/assets/js/utils"
  export default {
    props: [],
    data () {
      return {
        companyShow:false,
        manageListShow:false,
        quitDialog:false,
        userInfo:{

        },
        protocol:"onelinkplus.com",
        pageLoading:false
      }
    },
    components: {
      'company-change':companyChange,
      'manage-list':manageList,
      "toopbar":toopbar
    },
    computed:{
      ...mapState([
        'KP'
      ]),
      getTrueName(){
        let name=this.userInfo.trueName
        name=name?name.length<=2?name:name.substring(name.length-2):""
        if(this.userInfo.trueName&&this.userInfo.trueName.split(' ').length>1){
          name=this.userInfo.trueName.split(' ')[this.userInfo.trueName.split(' ').length-1]
        }
        return name
      }
    },
    created () {
    },
    mounted () {
      // console.info(onelink_mdata_userinfo)
      this.isLogin=this.getToken('isLogin')=='100'?true:false
      if(!this.isLogin){

        this.$router.replace({
          path: "/login",
          query: { redirectURL: window.location.href },
        });
      }
      // let userInfo = this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv) || "{}"
      // this.userInfo = JSON.parse(userInfo)
      this.findUserInfo()
      // console.info(this.userInfo,'this.userInfo')
    },
    methods: {

      findUserInfo(item=null){
        this.pageLoading=true
         this.$axios.post('/onelink.mdata.main.api/user/findUserInfo', {
            companyId: item?item.orgId:get('justId'),
            rememeberPassword: true,
            userId: item?item.userId:get('userId'),
        })
        .then((res) => {
          this.userInfo=res.data.uCenterMemberInforDto
          this.pageLoading=false
        })
        .catch((e) => {
          this.pageLoading=false
        });
      },
      closeCompanyDailog(){
        this.companyShow=false
      },
      openChangeCompany(){
        this.companyShow=true
      },
      changeItem(item){
        // console.info(item)
        this.findUserInfo(item)
        this.$refs.manageList.selectOrgManager()
      },
      openManage(){
        this.manageListShow=true
      },
      closeManageDailog(){
        this.manageListShow=false

      },
      // 退出
      quitClick(){
        /**
         * 清除登录状态
         */
        const removeKeys = [
          "isLogin",
          "userId",
          "justId",
          "userInfo",
          "companyInfo",
          "checkFlag",
          "examineStatus",
          "noticeInfos",
          "exmaineMessage",
          "regeisterType",
          "accessToken",
          "userTag",
          "messageNumber",
          "coordinationSupplierAuthFlag",
          "coordinationSystemAuthFlag",
          "supplierManagerAuthFlag",
          "isCompanyManager",
          onelink_mdata_userinfo
        ];

        for (let i = 0; i < removeKeys.length; i++) {
          removeStorage(removeKeys[i]);
          remove(removeKeys[i], { domain: this.protocol });
        }
        this.quitHandleClose()

        this.$router.replace({
          path: "/login",
          query: { redirectURL: window.location.href },
        });
      },
      quitHandleClose(){
        this.quitDialog=false
      },
      openQuit(){
        this.quitDialog=true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/myPage.vue